import React, { useEffect, useState } from 'react';
import { branchesAPI } from '../../services/api';
import { getStoredUser } from '../../utils/auth';
import { getDefaultBranchId } from '../../utils/roles';
import './BranchSwitcher.css';

const BranchSwitcher = () => {
    const [branches, setBranches] = useState([]);
    const [selectedBranchId, setSelectedBranchId] = useState(
        localStorage.getItem('selectedBranchId') || ''
    );

    useEffect(() => {
        branchesAPI.getAll().then((items) => {
            setBranches(items);
            if (!localStorage.getItem('selectedBranchId') && items.length) {
                const defaultId = getDefaultBranchId(items, getStoredUser());
                localStorage.setItem('selectedBranchId', defaultId);
                setSelectedBranchId(defaultId);
            }
        }).catch((error) => {
            console.error('Не удалось загрузить отделения:', error);
        });
    }, []);

    const handleBranchChange = (event) => {
        const value = event.target.value;
        localStorage.setItem('selectedBranchId', value);
        setSelectedBranchId(value);
        window.location.reload();
    };

    if (branches.length === 0) {
        return null;
    }

    return (
        <label className="branch-switcher">
            <span>Отделение</span>
            <select value={selectedBranchId} onChange={handleBranchChange}>
                {branches.map((branch) => (
                    <option key={branch.id} value={branch.id}>{branch.name}</option>
                ))}
            </select>
        </label>
    );
};

export default BranchSwitcher;
